export default {
      is_mobile: -1,
      slide_current:0,
      slides: [],
      slides_raw: [],
      auto_slide: true
    }